// Client ID
// sEptjHHbe1uaTP-ZLjas3Q
const apiKey = '4TG7fvAJxxse76NTi2g3MUDbllAM0J0bILOS6EVxdfbTtUEFSQqVfwDh4YgYG9-avDoB8TOjTEI7u1-xqax9NNfD9mRo7DM98sqJUy4gWfkyiy7vPi_k2i2KXXqOXXYx'
const Yelp = {
  search(term, location, sortBy) {
    return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`,{
        headers: {
            Authorization: `Bearer ${apiKey}`,
              }
      }).then(response=> {return response.json()}).then(jsonResponse=>{if
        (jsonResponse.businesses) {
        return jsonResponse.businesses.map(business=> {
          console.log(business);
          return {
            id: business.id,
            imageSrc: business.image_url,
            name: business.name,
            address: business.location.address1,
            city: business.location.city,
            state: business.location.state,
            zipCode: business.location.zip_code,
            category: business.categories[0].title,
            rating: business.rating,
            reviewCount: business.review_count,

             }})}});}
};

export default Yelp;
